export const MANDATORY_BILLING_PACKAGE_VALUE = 2500

export const MSISDN_LENGTH = 8

export const MINIMUM_AMOUNT_OF_PHONE_CREDITS = 0.5

export const offerProps = {
  TOP_PACK: 'Recomendados para ti',
  RECHARGE_PACK: 'Recargas',
  ITEM_NOT_FOUND: -1
}

export const PROMOTIONS = ['PAN-SINAI', 'COCACOLA-IRRESISTIBLE', 'PROMO-BAC']
